module.exports = __webpack_public_path__ + "static/img/-education-.5dc5a9e0.png";